import axios from "axios";
import internal from "stream";
import { ApiUrl } from "../../../utils/ApiUrl";

export const ResendOTP = async () => {
  const bookingID = parseInt(localStorage?.getItem("BookingId") || "");
  return axios
    .request({
      method: "PUT",
      url: `${ApiUrl}/bookings/${bookingID}/resendOtp`,
    })
    .then((res) => {
      if (res.status === 200) {
        return res;
      }
    })
    .catch((e) => {
      return e;
    });
};

export const verifyOTP = async (otpValue: string, bookingId: number) => {
  return axios
    .request({
      method: "POST",
      url: `${ApiUrl}/bookings/${bookingId}/verifyOtp`,
      data: {
        otpCode: otpValue,
        id: bookingId,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        return res;
      }
    })
    .catch((e) => {
      return e;
    });
};

export const sendOTP = async (bookingId: Number, email: String) => {
  return axios
    .request({
      method: "POST",
      url: `${ApiUrl}/bookings/RequestOTP`,
      data: {
        customer: {
          email: email,
        },
        bookingId: bookingId,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        return res;
      }
    })
    .catch((e) => {
      return e;
    });
};
